module.exports = __webpack_public_path__ + "static/026.thumb-03ab440f1c72886f43a4a68e9c24a3ad.jpg";